module.exports = __webpack_public_path__ + "img/apoio-sti.6af0a5f4.png";